import { scrollToSelector } from "./scroll.js"

const renderOrderData = (reviewButton, orderData) => {
  const elements = Object.values(orderData)
    .map(item => {
      if (Array.isArray(item.answer)) {
        return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.join(", ")}</p>
        </li>`;
      } else if (item.answer.answer) {
        return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.answer}</p>
        </li>`;
      } else {
        return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer}</p>
        </li>`;
      }
    })
    .join("");

  reviewButton.innerHTML = `<ul>${elements}</ul>`;
  jQuery('.review__button.close').css('display', 'block');
  scrollToSelector(".review__button")
};

export default renderOrderData
